export type ViewMode = 'sets' | 'types' | 'matrix'

interface ViewToggleProps {
  viewMode: ViewMode
  onChange: (mode: ViewMode) => void
}

export function ViewToggle({ viewMode, onChange }: ViewToggleProps) {
  return (
    <div className="inline-flex rounded-lg border border-mtg-border bg-mtg-card-bg p-0.5">
      <button
        type="button"
        onClick={() => onChange('sets')}
        className={`flex items-center gap-1.5 px-3 py-1.5 text-sm rounded-md transition-colors ${
          viewMode === 'sets'
            ? 'bg-mtg-hover-bg text-mtg-text'
            : 'text-mtg-text-muted hover:text-mtg-text'
        }`}
        aria-pressed={viewMode === 'sets'}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          aria-hidden="true"
        >
          <path d="M4 20h16a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.93a2 2 0 0 1-1.66-.9l-.82-1.2A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13c0 1.1.9 2 2 2Z" />
        </svg>
        Sets
      </button>
      <button
        type="button"
        onClick={() => onChange('types')}
        className={`flex items-center gap-1.5 px-3 py-1.5 text-sm rounded-md transition-colors ${
          viewMode === 'types'
            ? 'bg-mtg-hover-bg text-mtg-text'
            : 'text-mtg-text-muted hover:text-mtg-text'
        }`}
        aria-pressed={viewMode === 'types'}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          aria-hidden="true"
        >
          <rect width="7" height="7" x="3" y="3" rx="1" />
          <rect width="7" height="7" x="14" y="3" rx="1" />
          <rect width="7" height="7" x="14" y="14" rx="1" />
          <rect width="7" height="7" x="3" y="14" rx="1" />
        </svg>
        Types
      </button>
      <button
        type="button"
        onClick={() => onChange('matrix')}
        className={`flex items-center gap-1.5 px-3 py-1.5 text-sm rounded-md transition-colors ${
          viewMode === 'matrix'
            ? 'bg-mtg-hover-bg text-mtg-text'
            : 'text-mtg-text-muted hover:text-mtg-text'
        }`}
        aria-pressed={viewMode === 'matrix'}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          aria-hidden="true"
        >
          <rect width="18" height="18" x="3" y="3" rx="2" />
          <path d="M3 9h18" />
          <path d="M9 9v12" />
        </svg>
        Matrix
      </button>
    </div>
  )
}
